import { HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { Observable } from 'rxjs';

import { JSR310ConversionService } from '../../../shared/jsr310-localdates/services/jsr310-conversion.service';

import { JobsFilters } from '../entities/jobs-filters.entity';
import { JobProgressStatus } from "../entities/job-progress-status.entity";
import { PastJobDto } from '../entities/past-job-dto.entity';

@Injectable({ providedIn: 'root' })
export class JobService {
	private path!: string;

	constructor(
		@Inject(HttpClient) private httpClient: HttpClient, //
		@Inject(JSR310ConversionService) private jsr310Service: JSR310ConversionService, 
		@Optional() @SkipSelf() previousInstance?: JobService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
	}

	// Fonction utilitaire pour obtenir les httpParams issu d'un objet AccesSearchCriteria
	private getCriteriaAsParams(searchCriteria: JobsFilters): HttpParams {
		let httpParams = new HttpParams();
		for (let key in searchCriteria) {
			let value = (searchCriteria as any)[key];
			if (value !== null && value !== undefined) {
				if (key === 'date') {
					value = this.jsr310Service.toLocalDateParam2(value);
				}
				httpParams = httpParams.set(key, value);				
			}
		}
		return httpParams;
	}

	// Methode permettant de rechercher les jobs passes
	public searchHistory(searchCriteria: JobsFilters): Observable<PastJobDto[]> {
		let url = this.path + "/job-executions";
		let httpParams = this.getCriteriaAsParams(searchCriteria);
		httpParams = httpParams.set('pastOnly', 'true');
		
		return this.httpClient //
				.get<PastJobDto[]>(url, { params: httpParams }) //
		;		
	}
	
	public getProgress(id: number): Observable<JobProgressStatus | null> {
		let url = this.path + "/job-executions/" + id + "/progress";
		
		// On ajoute un header special pour empecher l'intercepteur d'afficher un indicateur de chargement
		let headers = new HttpHeaders().set("no-pending-trace", "true");
		
		return this.httpClient //
				.get<JobProgressStatus | null>(url, { headers: headers }) //
		;		
	}
}